import React from "react";
import { useCallbackPrompt } from "./useCallbackPrompt";
const Prompt = (props) => {
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    props.isDirty
  );
  return /* @__PURE__ */ React.createElement("span", { style: { display: "none" } }, "Prompt");
};
export default Prompt;
